import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { BaseService } from '../../base/base.service';
import { Config } from '../../models/Config';
import { RoleService } from '../role/role.service';
import { LoaderService } from '../loader/loader.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {
  httpClient = inject(HttpClient);
  roleService = inject(RoleService);
  loadingService = inject(LoaderService)
  constructor() { 
    super()
  }
    /*
    *   function name: login()
    *   functionality: login and get user details
    *   parameters : username and password
    */ 
  login(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_user_login`, data, {withCredentials: true})
      .pipe(tap((result) => {
        localStorage.setItem('authUser', JSON.stringify(result.data));          
      }));
  }

  plantCodewithName() {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_plant_name`, {}, this.getConfig())
      .pipe(tap((result) => {
        localStorage.setItem('cng_plant', JSON.stringify(result?.data));
      }));
  }
  forgotPassword(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_otp_verification_pass`, data, this.getConfig())
      // .pipe(tap((result) => {
      //   localStorage.setItem('authUser', JSON.stringify(result.data));
      // }));
  }
  getOtp(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_generate_otp`, data, this.getConfig())
    // .pipe(tap((result) => {
      //   localStorage.setItem('authUser', JSON.stringify(result.data));
      // }));
    }

  getCaptcha() {
    return this.httpClient.get<any>(`${this.getAppBaseUrl()}/cng_captcha`, {
      withCredentials: true
    })
  }
   /*
    *   function name: logout()
    *   functionality: logout 
    *   parameters : none
    */

  logout() {
    
    localStorage.removeItem('authUser');
    localStorage.removeItem('user_id');
    localStorage.removeItem('access_to');
  }

  logoutcall(data: any) {
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_user_logout`, data, this.getConfig())
  }

   /*
    *   function name: isLoggedIn()
    *   functionality: isLoggedIn 
    *   parameters : none
    */

   isLoggedIn(): boolean {
    const token = this.getToken();
    return !!token;
  }

  getToken(): string | null {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      try {
        const parsedData = JSON.parse(authUser); 
        return parsedData?.token || null; 
      } catch (error) {
        console.error("Error parsing authUser from localStorage:", error);
        return null;
      }
    }

    return null; // Return null if no authUser exists in localStorage
  }

  // Dummy method to update user permissions (in reality, you would make an API call)
  updateUserPermissions(data: any) {

    if (data.operation == "INSERT") {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_create_user`, data, this.getConfig())
    } else {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/update_cng_user`, data, this.getConfig())
    }


  }

  getLoggedId(): number {
    return Number(localStorage.getItem('user_id')) || 0;  // Get logged_id from localStorage
  }

  userLoginVerify(data: any) {
    this.loadingService.ignore_loading = true;
    return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_user_login_check`, data, this.getConfig())
    .pipe(tap((result) => {
      this.loadingService.ignore_loading = false;         
    }));
  }
}
